import dayjs from 'dayjs';
import { IMemory } from './IMemory';

// Builds the short "where this came from" line shown under a memory's fact text, e.g.
// "From a recording, Jun 28". Pure/side-effect-free, so it's a free function per the codebase
// convention (formatters don't need IoC/mocking) -- and its branching on sourceType is real enough
// to warrant the accompanying unit test.
export const formatMemorySourceLine = (memory: Pick<IMemory, 'sourceType' | 'sourceDate' | 'updatedAt'>): string => {
    if (memory.sourceType === 'user') {
        // sourceDate carries over from the original (pre-edit) source and never advances when the
        // user edits a memory, so it would show a stale date here. updatedAt is stamped fresh on
        // every edit, so it's the honest date for a user-authored row.
        return `You added this, ${dayjs(memory.updatedAt).format('MMM D')}`;
    }

    const date = dayjs(memory.sourceDate).format('MMM D');

    switch (memory.sourceType) {
        case 'recording':
            return `From a recording, ${date}`;
        case 'chat':
            return `From a chat with Bea, ${date}`;
        case 'synthesis':
            return `Bea noticed this pattern, ${date}`;
    }
};
